module.exports = __webpack_public_path__ + "3a45d2f443e7454b8baf01880a56f4df.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/trailer_preview-320.jpg
// module id = 554
// module chunks = 0